module.exports = __webpack_public_path__ + "img/placeholder/ChAuj-article-card-1.jpg";